"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5365],{

/***/ 85365:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ TravelProtection_TravelProtection)
});

// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 5 modules
var insurance = __webpack_require__(83636);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 5 modules
var navigation = __webpack_require__(576);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var src = __webpack_require__(76609);
// EXTERNAL MODULE: ../../libs/ui/src/lib/hooks/index.ts + 1 modules
var hooks = __webpack_require__(89565);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/routeConstants.ts
var routeConstants = __webpack_require__(60251);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/EducationModal/EducationModal.tsx + 1 modules
var EducationModal = __webpack_require__(9840);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/FormattedText/FormattedText.tsx
var FormattedText = __webpack_require__(17871);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelProtection/TravelProtection.style.ts

const TravelProtectionWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionstyle__TravelProtectionWrapper",
  componentId: "sc-1t9rpy0-0"
})(["font-family:-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,Oxygen,Ubuntu,Cantarell,\"Open Sans\",\"Helvetica Neue\",sans-serif;background:#ffffff;border-radius:16px;box-shadow:0 2px 8px rgba(0,0,0,0.1);width:1200px;margin:0 auto;padding:20px 30px;"]);
const ProtectionTitle = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "TravelProtectionstyle__ProtectionTitle",
  componentId: "sc-1t9rpy0-1"
})(["font-size:24px;margin-bottom:24px;font-weight:700;"]);
const ProtectionPlans = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionstyle__ProtectionPlans",
  componentId: "sc-1t9rpy0-2"
})(["display:flex;flex-wrap:wrap;gap:20px;@media (max-width:768px){flex-direction:column;}"]);
const PlanCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionstyle__PlanCard",
  componentId: "sc-1t9rpy0-3"
})(["background:#ffffff;border-radius:16px;border:1px solid #d8d8d8;padding:12px;display:flex;width:100%;max-width:332px;cursor:pointer;transition:transform 0.2s,box-shadow 0.2s;@media (max-width:768px){max-width:100%;}"]);
const PlanIconContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionstyle__PlanIconContainer",
  componentId: "sc-1t9rpy0-4"
})(["position:relative;width:51px;height:51px;flex-shrink:0;margin:8px 12px 0px 0px;display:flex;border-radius:16px;justifycontent:center;alignitems:center;"]);
const PlanIcon = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "TravelProtectionstyle__PlanIcon",
  componentId: "sc-1t9rpy0-5"
})(["width:51px;height:51px;"]);
const PlanTag = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "TravelProtectionstyle__PlanTag",
  componentId: "sc-1t9rpy0-6"
})(["position:absolute;top:-10px;right:-10px;width:32px;height:32px;"]);
const PlanDetails = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionstyle__PlanDetails",
  componentId: "sc-1t9rpy0-7"
})(["flex-grow:1;display:flex;flex-direction:column;h3{margin:0 0 8px;font-size:18px;}p{margin:0 0 12px;font-size:14px;color:#4a4a4a;}"]);
const TitleContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionstyle__TitleContainer",
  componentId: "sc-1t9rpy0-8"
})(["display:flex;align-items:center;"]);
const TagImage = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "TravelProtectionstyle__TagImage",
  componentId: "sc-1t9rpy0-9"
})(["width:38px;height:38px;object-fit:contain;"]);
const TagContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionstyle__TagContainer",
  componentId: "sc-1t9rpy0-10"
})(["margin-left:8px;display:flex;align-items:center;"]);
const KnowMoreLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "TravelProtectionstyle__KnowMoreLink",
  componentId: "sc-1t9rpy0-11"
})(["font-size:14px;text-decoration:none;"]);
const ModalOverlay = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionstyle__ModalOverlay",
  componentId: "sc-1t9rpy0-12"
})(["position:fixed;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,0.5);display:flex;justify-content:center;align-items:center;z-index:1000;"]);
const ModalContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionstyle__ModalContent",
  componentId: "sc-1t9rpy0-13"
})(["background-color:#ffffff;border-radius:8px;width:90%;max-width:480px;max-height:80vh;overflow-y:auto;padding:24px;box-shadow:0 5px 15px rgba(0,0,0,0.2);@media (max-width:768px){width:95%;padding:16px;}"]);
const ModalBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionstyle__ModalBody",
  componentId: "sc-1t9rpy0-14"
})(["margin-bottom:24px;"]);
const ModalFooter = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "TravelProtectionstyle__ModalFooter",
  componentId: "sc-1t9rpy0-15"
})(["display:flex;justify-content:space-between;"]);
const ModalButton = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "TravelProtectionstyle__ModalButton",
  componentId: "sc-1t9rpy0-16"
})(["padding:8px 24px;border:none;border-radius:4px;cursor:pointer;font-size:16px;"]);
const BackButton = (0,styled_components_browser_esm/* default */.ZP)(ModalButton).withConfig({
  displayName: "TravelProtectionstyle__BackButton",
  componentId: "sc-1t9rpy0-17"
})(["background-color:#f2f2f2;"]);
const NextButton = (0,styled_components_browser_esm/* default */.ZP)(ModalButton).withConfig({
  displayName: "TravelProtectionstyle__NextButton",
  componentId: "sc-1t9rpy0-18"
})(["background-color:#008cff;color:#ffffff;"]);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/components/TravelProtection/TravelProtection.tsx













const TravelProtection = ({
  title,
  plans
}) => {
  const {
    setType
  } = (0,src/* usePlanType */.U)();
  const {
    0: activePlan,
    1: setActivePlan
  } = (0,react.useState)(plans?.[0] || null);
  const {
    0: currentPageIndex,
    1: setCurrentPageIndex
  } = (0,react.useState)(0);
  const {
    0: showModal,
    1: setShowModal
  } = (0,react.useState)(false);
  const analytics = (0,insurance/* getAnalytics */.I)(); // Track component view when it comes into viewport

  const handleIntersection = (0,react.useCallback)(data => {
    (0,XDMAnalytics.trackComponentView)({
      name: "travel_protection_plans_shown",
      type: "card"
    });
  }, []);
  const {
    ref: intersectionRef
  } = (0,hooks/* useIntersectionObserver */.S)(handleIntersection, {
    threshold: 0.5,
    // Trigger when 50% of component is visible
    triggerOnLeaveViewport: true
  }); // Education modal tracking handlers

  const handleEducationModalShown = () => {
    analytics?.trackLandingEvents?.({
      actionType: "educationModal_shown"
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "educationModal_shown"
      }
    });
  };

  const handleEducationModalNextClick = () => {
    analytics?.trackLandingEvents?.({
      actionType: "educationModal_next_click"
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "educationModal_next_click"
      }
    });
  };

  const handleEducationModalSkipClick = () => {
    analytics?.trackLandingEvents?.({
      actionType: "educationModal_skip_click"
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "educationModal_skip_click"
      }
    });
  };

  const handleEducationModalPageShown = pageId => {
    analytics?.trackLandingEvents?.({
      actionType: `educationModal_${pageId}_shown`
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `educationModal_${pageId}_shown`
      }
    });
  };

  const handleEducationSkip = () => {
    setShowModal(false);
    setType(activePlan?.type);
    navigation/* navigationActions.navigateToLanding */.ej.navigateToLanding({
      type: activePlan?.type
    }, false);
  };

  const handlePlanClick = plan => {
    analytics?.trackCommonLandingEvents({
      actionType: `protection_plan_${plan.type}_clicked`
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `protection_plan_${plan.type}_clicked`
      }
    });
    (0,XDMAnalytics.triggerPageExit)();

    if (plan.showPages) {
      setActivePlan(plan);
      setCurrentPageIndex(0);
      setShowModal(true);
    } else {
      setType(plan.type);
      navigation/* navigationActions.navigateToRouteNameWithHostname */.ej.navigateToRouteNameWithHostname(routeConstants/* ROUTE_CONSTANTS.INSURANCE_V1_LANDING */.j.INSURANCE_V1_LANDING, {
        type: plan?.type
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravelProtectionWrapper, {
    ref: intersectionRef,
    "data-test-id": "TravelProtection-TravelProtectionWrapper",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ProtectionTitle, {
      "data-test-id": "TravelProtection-ProtectionTitle",
      children: title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
        value: title,
        "data-test-id": "TravelProtection-FormattedText"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ProtectionPlans, {
      "data-test-id": "TravelProtection-ProtectionPlans",
      children: plans?.filter(plan => plan.type === "flt-delay").map((plan, index) => /*#__PURE__*/(0,jsx_runtime.jsxs)(PlanCard, {
        onClick: () => handlePlanClick(plan),
        "data-test-id": `TravelProtection-PlanCard-${index}`,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PlanIconContainer, {
          style: {
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          },
          "data-test-id": "TravelProtection-PlanIconContainer",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PlanIcon, {
            src: plan.icon,
            alt: "planIcon",
            "data-test-id": "TravelProtection-PlanIcon"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(PlanDetails, {
          "data-test-id": "TravelProtection-PlanDetails",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(TitleContainer, {
            "data-test-id": "TravelProtection-TitleContainer",
            children: [plan.title && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
              value: plan.title,
              baseStyle: {
                fontWeight: 700,
                fontSize: 18
              },
              "data-test-id": "TravelProtection-FormattedText"
            }), plan.tagURL && /*#__PURE__*/(0,jsx_runtime.jsx)(TagContainer, {
              "data-test-id": "TravelProtection-TagContainer",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(TagImage, {
                src: plan.tagURL,
                alt: "New",
                "data-test-id": "TravelProtection-TagImage"
              })
            })]
          }), plan?.info && /*#__PURE__*/(0,jsx_runtime.jsx)(FormattedText/* default */.Z, {
            value: plan?.info,
            baseStyle: {
              fontSize: 14,
              color: "#4a4a4a"
            },
            "data-test-id": "TravelProtection-FormattedText"
          })]
        })]
      }, index))
    }), showModal && activePlan && activePlan.showPages && /*#__PURE__*/(0,jsx_runtime.jsx)(EducationModal/* default */.Z, {
      pagesData: activePlan.pages,
      knowMore: activePlan.knowMore,
      setShowEducationModal: setShowModal,
      skipButtonHandler: handleEducationSkip,
      onModalShown: handleEducationModalShown,
      onNextClick: handleEducationModalNextClick,
      onSkipClick: handleEducationModalSkipClick,
      onPageShown: handleEducationModalPageShown,
      "data-test-id": "TravelProtection-EducationModal"
    })]
  });
};

/* harmony default export */ const TravelProtection_TravelProtection = (TravelProtection);

/***/ })

}]);